import { checkDate } from "common/helpers/Date";
import { Record } from "immutable";
import { DateStringNumber } from "common/records";

export const fromJSON = (json: Partial<INoteData>): NoteRecord => {
  const recordData: INoteRecord = { ...(json as any) };

  if (json.created_at) {
    recordData.created_at = checkDate(json.created_at);
  }

  if (json.updated_at) {
    recordData.updated_at = checkDate(json.updated_at);
  }

  return new NoteRecord(recordData);
};

export interface INoteData {
  id: number;
  note: string;
  user: string;
  user_id: number;
  metadata: any;
  noteable_id: number;
  noteable_type: string;
  loading?: boolean;

  created_at: DateStringNumber;
  updated_at: DateStringNumber;
}

export interface INoteRecord {
  id: number;
  note: string;
  user: string;
  user_id: number;
  metadata: any;
  noteable_id: number;
  noteable_type: string;
  loading: boolean;

  created_at: Date;
  updated_at: Date;
}

export const defaultNoteProps: INoteRecord = {
  id: 0,
  note: "",
  user_id: 0,
  metadata: {},
  noteable_id: 0,
  noteable_type: "",
  user: "",
  loading: true,

  created_at: new Date(),
  updated_at: new Date(),
};

export class NoteRecord extends Record(defaultNoteProps) implements INoteRecord {}
